import qs from 'qs';
import Vue from "vue";

import eventsModule from "./type";
import chatModule from '@chat/module/store/type';
import mixin from '@general/lib/mixin';

import { _type as sidebarType } from '@general/modules/sidebar'
import newGroupMessageReceivedListener from '@chat/lib/listeners/newGroupMessageReceivedListener'
import updateGroupMessageListener from '@chat/lib/listeners/updateGroupMessageListener'
import axios from "axios";

const actions = {
    async [eventsModule.actions.getStickyEvents] ({state, commit}) {
        try {
            let location = localStorage.getItem('location') ? {location: JSON.parse(localStorage.getItem('location'))} : {};
            let response = await axios.post('/api/stickyEvents',location)
            if (response.status === 200) {
                let data = response.data
                if (!data) {
                    return 0
                }

                commit(eventsModule.mutations.setStickyEvents, data)
            }
        } catch (error) {
            console.error(error)
        }
    },
    [eventsModule.actions.setBang]({commit}, payload) {
        if (payload.visible === false) {
            payload.mode = 'view'
            payload.eventId = null
        }
        commit(eventsModule.mutations.setBang, payload)
    },
    [eventsModule.actions.setSpot]({commit}, payload) {
        if (payload.visible === false) {
            payload.mode = 'view'
            payload.id = null
        }else{
            payload.id = payload.eventId
        }
        commit(eventsModule.mutations.setSpot, payload)
    },
    [eventsModule.actions.setEvent]({commit}, payload) {
        if (payload.visible === false) {
            payload.mode = 'view'
            payload.eventId = null
        }
        commit(eventsModule.mutations.setEvent, payload)
    },
    [eventsModule.actions.setType]({commit}, type) {
        commit(eventsModule.mutations.setType, type)
    },
    [eventsModule.actions.initFilter]({dispatch}) {
        let typeCached = localStorage.getItem('events-type')

        if (typeCached === 'friends') {
            typeCached = 'guide'
        }

        if (typeCached) {
            dispatch(eventsModule.actions.setType, typeCached)
        }
    },
    [eventsModule.actions.events.like]({store, commit, getters}, event) {
        if(getters[eventsModule.getters.getEventLikeInProcess]){
            return false;
        }
        commit(eventsModule.mutations.setEventLikeInProcess, event.id)
        if (!event.isLiked) {
            event.isLiked = true;
            commit(eventsModule.mutations.setLikes, event);
            axios.post(`/api/likeEvent`, {eventId: event.id})
                .then(() => {
                    commit(eventsModule.mutations.setEventLikeInProcess, 0)
                })
                .catch(() => {
                    commit(eventsModule.mutations.setEventLikeInProcess, 0)
                })
        } else {
            event.isLiked = false;
            commit(eventsModule.mutations.setLikes, event);
            axios.post(`/api/dislikeEvent`, {eventId: event.id})
                .then(() => {
                    commit(eventsModule.mutations.setEventLikeInProcess, 0)
                })
                .catch(() => {
                    commit(eventsModule.mutations.setEventLikeInProcess, 0)
                })
        }
    },
    [eventsModule.actions.events.report](store, data) {
        axios.post('/api/reportEvent', data)
            .then(response => {
                data.callback(response)
            })
    },
    async [eventsModule.actions.events.loadMy]({state, commit}) {
        try {
            let response = await axios.get('/api/user/load-events')
            if (response.status === 200) {
                let data = response.data
                if (!data) {
                    return 0
                }

                commit('setMyEvents', response.data)

                return data.length
            }
        } catch (error) {
            console.error(error)
        }
        return 0
    },
    async [eventsModule.actions.events.loadMembers]({dispatch, state, commit}, bang) {
        if(typeof state.members_page == 'undefined'){
            commit(eventsModule.mutations.events.setPageMembersNum, 0)
        }
        let payload = {
            page: state.members_page + 1,
            limit: 100
        }
        let location = JSON.parse(localStorage.getItem('location'));
        if(location){
            payload.location = location;
        }

        try {
            let response = await axios.get('/api/event/load-members/'+bang.id, {params: payload})
            if (response.status === 200) {
                let data = response.data
                if (!data) {
                    return true
                }
                $.each(['members','invitedMembers'],function (key,val){
                    if(typeof bang[val] == 'undefined'){
                        bang[val] = [];
                    }
                    bang[val] = bang[val].concat(data[val]);
                })
                dispatch(eventsModule.actions.events.update, bang)
                commit(eventsModule.mutations.events.setPageMembersNum, payload.page)
                return data && (data.members.length === bang.members_count ||
                    !data.members.length);
            }
        } catch (error) {
            console.error(error)
        }

        return true
    },
    async [eventsModule.actions.spots.load]({state, commit}, payload) {
        payload.page = state.spots_page
        if(localStorage.getItem('location')){
            //payload.location = JSON.parse(localStorage.getItem('location'));
        }

        try {
            let response = await axios.post('/api/spots/index', payload)
            if (response.status === 200) {
                let data = response.data
                if (!data) {
                    return 0
                }

                // Add dates
                commit(eventsModule.mutations.spots.addSpots, data)
                commit(eventsModule.mutations.spots.setSpotPageNum)

                return data.length
            }
        } catch (error) {
            console.error(error)
        }
        return 0
    },
    async [eventsModule.actions.events.load]({state, commit}) {
        let type  = [state.type];
        let payload = {
            type: type
        }  

        payload.page = state.page
        payload.limit = window.LOAD_EVENTS_DATES_PER_PAGE
        if(localStorage.getItem('location')){
            payload.location = JSON.parse(localStorage.getItem('location'));
        }

        try {
            let response = await axios.post('/api/eventsAround', payload)
            if (response.status === 200) {
                let data = response.data
                if (!data) {
                    return 0
                }

                // Add dates
                commit(eventsModule.mutations.events.addDates, data)
                commit(eventsModule.mutations.events.setPageNum, { date: null, value: '+1'})

                return data.length
            }
        } catch (error) {
            console.error(error)
        }
        return 0
    },
    async [eventsModule.actions.events.loadMoreByDate]({state, commit, getters}, { date, index }) {
        let payload = {
            type: [state.type]
        }

        let existedDateIndex = state.eventDates.findIndex(v => v.date === date)
        if (existedDateIndex === -1)
            return

        let existedEntry = state.eventDates[existedDateIndex]
        if (!existedEntry.events_range_high_count) {
            return
        }

        payload.page = existedEntry.page || 0
        payload.date = date
        payload.limit = window.LOAD_EVENTS_PER_DATE_NEXT
        payload.except = getters[eventsModule.getters.eventIdsByDate](date)
        if(localStorage.getItem('location')){
            payload.location = JSON.parse(localStorage.getItem('location'));
        }

        try {
            // Show preloader
            commit(eventsModule.mutations.setDateLoading, { date, value: true })

            let response = await axios.post('/api/eventsAround', payload)
            if (response.status === 200) {
                let data = response.data
                if (!data) {
                    return 0
                }

                // Hide preloader
                commit(eventsModule.mutations.setDateLoading, {date, value: false})
                $.each(data,function (key, val){
                  if(val.events_range_high.length < payload.limit){
                    data[key]['events_range_high_count'] = 0;
                  }
                })
                // Add events to list
                commit(eventsModule.mutations.events.addDates, data)
                commit(eventsModule.mutations.events.setPageNum, { date, value: '+1'})
            }
        } catch (error) {
            console.error(error)
        }
    },
    async [eventsModule.actions.events.loadInfo](context, payload) {

        let CancelToken = axios.CancelToken
        app.EventInfoCancelSource = CancelToken.source()
        try {
            const location = localStorage.getItem('location');
            let response = await axios.get(`/api/eventInfo/${payload.eventId}/${payload.edit}?location=${location}`,
                {
                    cancelToken: app.EventInfoCancelSource.token
                })
            if (response.status === 200) {
                console.log('[Event info loaded]',payload.eventId)
                if(payload.dont_reset_members && context.rootState.eventsInfo[payload.eventId]){
                    response.data['members'] = context.rootState.eventsInfo[payload.eventId]['members']
                }

                store.commit(eventsModule.mutations.events.update, {
                  eventId:   payload.eventId,
                  eventData: response.data
                })
                Vue.set(context.rootState.eventsInfo, payload.eventId, response.data)
                return response.data
            }
        } catch (error) {
            console.log(error)
        }
        return null
    },
    async [eventsModule.actions.spot.loadInfo](context, payload) {
        try {
            let response = await axios.get(`/api/spot/${payload.id}/${payload.edit}`)
            if (response.status === 200) {
                console.log('[Spot info loaded]',payload.id)
                Vue.set(context.rootState.spotsInfo, payload.id, response.data)
                return response.data
            }
        } catch (error) {
            console.log(error)
        }
    },
    async [eventsModule.actions.spot.submit]({rootState, dispatch, commit }, data) {
        console.log('[Spot Submit] Payload]', { data })

        let updatePerformed = data.id
        let params = []
        if (updatePerformed) {
            params = [
                `/api/updateSpot/${data.id}`,
                data,
                {'Content-Type': 'application/json'}
            ]
        } else {
            params = [
                '/api/createSpot',
                qs.stringify(data),
                {'Content-Type': 'application/x-www-form-urlencoded'}
            ]
        }
        let eventData = null
        return new Promise((resolve,reject) => {
            axios.post(...params).then((response) => {
                let spotData = response.data
                Vue.set(rootState.spotsInfo, spotData.id, spotData)
                if (updatePerformed) {
                    mixin.methods.showSuccessNotification('spot_successfully_updated')
                }else{
                    mixin.methods.showSuccessNotification('spot_successfully_added')
                }


                resolve(spotData)
            }).catch( (error) => {
                if(error.status === 422) {
                    mixin.methods.showErrorNotification(error.data.error)
                }
                reject(error)
            });

        });
    },
    async [eventsModule.actions.events.submit]({ dispatch, commit }, data) {
        console.log('[Event Submit] Payload]', { data })

        let updatePerformed = data.id
        let params = []
        if (updatePerformed) {
            params = [
                `/api/updateEvent/${data.id}`,
                data,
                {'Content-Type': 'application/json'}
            ]
        } else {
            params = [
                '/api/createEvent',
                qs.stringify(data),
                {'Content-Type': 'application/x-www-form-urlencoded'}
            ]
        }
        let eventData = null
        return new Promise((resolve,reject) => {
            axios.post(...params).then((response) => {
                eventData = response.data
                console.log('[Submit Event] Response', { response })
                if (!!eventData.type) {
                    dispatch(eventsModule.actions.setType, eventData.type)
                }

                // Created
                if (!updatePerformed) {
                    mixin.methods.showSuccessNotification('event_successfully_added')
                    commit('addMyEvents', [eventData])

                    if (app.isDesktop) {
                        dispatch(eventsModule.actions.setBang, { visible: false })
                        dispatch(eventsModule.actions.setEvent, { visible: false })
                    } else {
                        dispatch(sidebarType.actions.hide)
                        app.goTo('/events')
                    }

                    // Listen to new event channel
                    if (eventData.type === 'bang') {
                        dispatch(eventsModule.actions.membership.addMy, eventData.id)
                    }

                    setTimeout(function(){
                        app.$emit('reload-events')
                    }, 750)

                    // Updated
                } else {
                    mixin.methods.showSuccessNotification('event_successfully_updated')
                    dispatch(eventsModule.actions.events.update, eventData)

                    if (app.isDesktop) {
                        dispatch(eventsModule.actions.setBang, { visible: false })
                        dispatch(eventsModule.actions.setEvent, { visible: false })

                        setTimeout(function(){
                            app.$emit('reload-events')
                        }, 750)
                    } else {
                        app.goTo(
                            eventData.type === 'bang' ?
                                `/bang/${eventData.id}`
                                :
                                `/event/${eventData.id}`
                        )
                    }
                }
                resolve('Ok')
            }).catch( (error) => {
                if(error.status === 422) {
                    mixin.methods.showErrorNotification(error.data.error)
                }
                reject('Error')
            });

        });
    },
    async [eventsModule.actions.spots.remove]({ dispatch, commit }, spotId) {
        dispatch('showDialog', {
            mode: 'confirm',
            message: app.trans('sure_delete_spot'),
            callback: async () => {
                console.log('[Delete Spot] Callback')
                let response = await axios.post(`/api/removeSpot/${spotId}`)
                if (response.status === 200) {
                    commit(eventsModule.mutations.spots.removeSpot, spotId)
                    if (app.isDesktop) {
                        // Close event modal
                        dispatch(eventsModule.actions.setSpot, { visible: false })

                    } else if (app.isMobile) {
                        app.goTo('/create-event?spots=1')
                    }
                }
            }
        })
    },
    async [eventsModule.actions.events.remove]({ dispatch, commit }, eventId) {
        dispatch('showDialog', {
            mode: 'confirm',
            message: app.trans('sure_delete_event'),
            callback: async () => {
                console.log('[Delete Event] Callback')
                let response = await axios.post(`/api/removeEvent/${eventId}`)
                if (response.status === 200) {
                    dispatch(eventsModule.actions.events.cleanUp, {
                        eventId,
                        removeFromEventList: true
                    })
                }
            }
        })
    },
    [eventsModule.actions.events.cleanUp]({ dispatch, commit }, { eventId, removeFromEventList }) {
        if (removeFromEventList) {
            // Remove event from events list
            commit(eventsModule.mutations.events.remove, eventId)
        }

        // Remove event from myEvents list
        commit('removeFromMyEvents', eventId)
        // Remove conversation
        dispatch(chatModule.actions.conversations.remove, {eventId})
        // Remove my membership
        dispatch(eventsModule.actions.membership.removeMy, eventId)

        if (app.isDesktop) {
            // Close event modal
            dispatch(eventsModule.actions.setBang, { visible: false })
            dispatch(eventsModule.actions.setEvent, { visible: false })

            // Close event chat
            let eventModal = store.state.chatModule.modal
            if (
                eventModal.event
                &&
                eventModal.event.id == eventId
            ) {
                store.commit(chatModule.mutations.modal, {
                    event: null,
                    user: null,
                    mode: null,
                    minimized: false
                })
            }
        } else if (app.isMobile) {
            let routeEventId = app.$route.params && app.$route.params.eventId

            // Exit event chat
            if (['chat-group', 'chat-event-user'].includes(app.$route.name)) {
                app.goTo('/chat')

            // Exit event
            } else if (
                ['edit-event', 'edit-bang', 'bang', 'event'].includes(app.$route.name)
                &&
                routeEventId == eventId
            ) {
                app.goTo('/events')
            }
        }
    },
    [eventsModule.actions.resetPagination]({ commit }) {
        commit(eventsModule.mutations.resetPagination)
    },

    [eventsModule.actions.events.updateMembers]({ dispatch, commit, rootState },{event_id,members}){
        if (
            event_id
            &&
            rootState.eventsInfo[event_id]
        ) {
            Vue.set(
                rootState.eventsInfo[event_id],
                'members',
                members
            )
        }
    },
    [eventsModule.actions.events.updateInvitedMembers]({ dispatch, commit, rootState },{event_id,members}){
        if (
            event_id
            &&
            rootState.eventsInfo[event_id]
        ) {
            Vue.set(
                rootState.eventsInfo[event_id],
                'invitedMembers',
                members
            )
        }
    },
    [eventsModule.actions.events.update]({ dispatch, commit, rootState }, eventData) {
        if (eventData.id) {
            // My events
            commit('updateMyEvent', eventData)

            // Chat list
            dispatch(chatModule.actions.conversations.updateConversationEvent, {
                eventId: eventData.id,
                eventData: eventData
            })
        }

        if (eventData.id) {
            // Events list
            commit(eventsModule.mutations.events.update, {
                eventId: eventData.id,
                eventData: eventData
            })
        }

        // Events cached info
        if (
            eventData.id
            &&
            rootState.eventsInfo[eventData.id]
        ) {
            Vue.set(
                rootState.eventsInfo,
                eventData.id,
                {...rootState.eventsInfo[eventData.id], ...eventData}
            )
        }
    },
    async [eventsModule.actions.membership.request](store, { eventId, userId, action}) {
        try {
            let response = await axios.post('/api/eventMembership', {
                eventId,
                userId,
                action
            })
            if (response.status === 200) {
                if (action === 'leave') {
                    // Clean up
                    store.dispatch(eventsModule.actions.events.cleanUp, {
                        eventId,
                        removeFromEventList: false
                    })
                }
            }
        } catch (error) {
            console.log(error)
        }
    },
    [eventsModule.actions.membership.set](store, payload) {
        payload.forEach(id => {
            store.dispatch(eventsModule.actions.membership.add, id)
        })
    },
    [eventsModule.actions.membership.setMy](store, payload) {
        payload.forEach(id => {
            store.dispatch(eventsModule.actions.membership.addMy, id)
        })
    },
    [eventsModule.actions.membership.add](store, eventId) {
        store.commit(eventsModule.mutations.membership.add, eventId)
    },
    [eventsModule.actions.membership.remove](store, eventId) {
        store.commit(eventsModule.mutations.membership.remove, eventId)
    },
    [eventsModule.actions.membership.addMy](store, eventId) {
        store.commit(eventsModule.mutations.membership.addMy, eventId)
        store.dispatch(eventsModule.actions.membership.subscribe, eventId)
    },
    [eventsModule.actions.membership.removeMy](store, eventId) {
        store.commit(eventsModule.mutations.membership.removeMy, eventId)
        store.dispatch(eventsModule.actions.membership.unsubscribe, eventId)
    },
    [eventsModule.actions.membership.subscribe](store, eventId) {
        if (window.Echo) {
            console.log('[Echo] Listening to channel-group-chat-' + eventId)
            window.Echo.private('channel-group-chat-' + eventId)
                .listen('NewGroupMessageReceived', newGroupMessageReceivedListener)
                .listen('UpdateGroupMessage', updateGroupMessageListener)
        } else {
            console.log('[Echo] No Echo. Cannot listen to channel-group-chat-' + eventId)
        }
    },
    [eventsModule.actions.membership.unsubscribe](store, eventId) {
        if (window.Echo) {
            console.log('[Echo] Leaving channel-group-chat-' + eventId)
            window.Echo.leave('channel-group-chat-' + eventId)
        } else {
            console.log('[Echo] No Echo. Cannot unsubscribe from channel-group-chat-' + eventId)
        }
    },
    [eventsModule.actions.membership.unsubscribeFromAll](store) {
        let memberships = store.state.myMemberships
        for (let eventId in memberships) {
            store.dispatch(eventsModule.actions.membership.unsubscribe, eventId)
        }
    }
}

export default actions
